import React from 'react';
import styled from '@emotion/styled';

const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding:40px 0;
  margin-top: 50px;
  background: ${props => props.theme.colors.primary.lighter};
`;
const SectionTitle = styled.h2`
  font-size: 26px;
  margin: 0 0 30px 0;
  color: ${props => props.theme.colors.black.base};
`;
const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1200px;

  @media (min-width: ${props => props.theme.breakpoints.s}) and (max-width: ${props => props.theme.breakpoints.m}) {
    width: 90%;
  }

  @media (max-width: ${props => props.theme.breakpoints.s}) {
    width: 95%;
  }
`;
const ListWrapper = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: ${props => props.theme.breakpoints.m}) {
    flex-wrap: wrap;
  }
`;
const List = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 20px;

  @media (max-width: ${props => props.theme.breakpoints.m}) {
    min-width: 300px;
  }
`;
const ListItem = styled.div`
  display: flex;
  flex-direction: row;
  padding: 8px 0;
`;
const ListItemIconWrapper = styled.div`
  display: flex;
  width: 40px;
  align-items: center;
`;
const ListItemText = styled.div`
  font-size: 15px;
  font-weight: 600;
  font-family: ${props => props.theme.fontFamily.body};
`;

const ServiceCatalogues = props => {
    const { list1, list2 } = props.items ? props.items : {}
    console.log('ServiceCatalogues', list1, list2);

    return (
        <Section>
            <ContentWrapper>
                <SectionTitle>Our go-to service catalogue</SectionTitle>
                <ListWrapper>
                    {list1 && <ItemsList items={list1} />}
                    {list2 && <ItemsList items={list2} />}
                </ListWrapper>
            </ContentWrapper>
        </Section>
    );
};

const ItemsList = props => props.items ? (
    <List>
        {props.items.map((item, idx) => {
            console.log('ITEM', item);

            const ListItemIcon = styled(item.icon)`
                width: 24px;
                height: 24px;
            `
            return (
                <ListItem key={idx}>
                    <ListItemIconWrapper>
                        <ListItemIcon />
                    </ListItemIconWrapper>
                    <ListItemText>{item.title}</ListItemText>
                </ListItem>
            )
        })}
    </List>
) : null

export default ServiceCatalogues;
